import { render, staticRenderFns } from "./review-dialog.vue?vue&type=template&id=fa8bd734&"
import script from "./review-dialog.vue?vue&type=script&lang=js&"
export * from "./review-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports